<template>
  <ModalInputTemplate
    v-if="tender && computedProps.show"
    ref="modalTemplate"
    :btn-text="computedProps.btnText"
    :callback="apply"
    :data-qa="computedProps.dataQa"
    :first-button="computedProps.firstButton"
    :list="list"
    :modal-title="computedProps.title">
    <template #activatorBtn="{ open }">
      <MenuItem
        v-if="list"
        class="h11-links"
        :data-qa="`${computedProps.dataQa}-list-item`"
        :icon="mode === 'complate_ahead' ? 'calendar-close' : 'cancel'"
        :label="computedProps.btnText"
        @click.stop="open"/>
      <sButton
        v-else
        color="var(--white-color)"
        data-qa="btn-open-cancel-tender"
        :icon="mode === 'complate_ahead' ? 'calendar-close' : 'cancel'"
        :rounded="false"
        type="text"
        @click.stop="open">
        {{ computedProps.btnText }}
      </sButton>
    </template>
  </ModalInputTemplate>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'

import SmarttenderApi from '@/api/smarttenderApi'
const st_api = new SmarttenderApi()

import { tenderMixin } from 'mixins'

export default {
  name: 'ModalCancelOrRejectTender',
  mixins: [ tenderMixin ],
  methods: {
    async apply(text) {
      if (this.mode === 'complate_ahead') {
        await st_api.tenderWithdrawal(this.tender.tenderId, text)
      } else {
        await st_api.tenderCancel(this.tender.tenderId, text)
      }
      await this.$_updateStatus(this.tender)
      await this.$_updateTenderAccess(this.tender)
      if (typeof this.callback === 'function') {
        await this.callback()
      }
    }
  },
  computed: {
    computedProps() {
      const status = this.tender.tenderStatus?.id || this.tender.tenderStatusId
      const analysis = status == 3
      const acceptance = status == 4
      const prequalification = status == 5
      const auction = status == 7

      // Заголовок
      let title = ''
      if (this.mode === 'complate_ahead') {
        title = `${this.$t('Tenders.WhyCompleteAheadOfSchedule')} #${this.tender.tenderNumber}`
      } else if (this.mode === 'cancel') {
        title = `${this.$t('Tenders.WhyCancelTender')} #${this.tender.tenderNumber}`
      }

      // Текст кнопки в модалке
      let btnText = ''
      if (this.mode === 'complate_ahead') {
        btnText = this.$t('Tenders.CompleteAheadOfSchedule')
      } else if (this.mode === 'cancel') {
        btnText = this.$t('Tenders.CancelTender')
      }

      // Текст кнопки/эллемента меню
      let firstButton = ''
      if (this.mode === 'complate_ahead') {
        firstButton = this.$t('Tenders.Complete')
      } else if (this.mode === 'cancel') {
        firstButton = this.$t('Common.Cancel')
      }

      // Логика отображения
      let show = false
      if (this.mode === 'complate_ahead' && (auction || acceptance)) {
        show = this.$can('earlyRemove', 'Tender')
      } else if (this.mode === 'cancel') {
        const defaultLogic = (auction || prequalification || acceptance || analysis) && this.$can('cancel', 'Tender')
        const DTECLogic = [10, 11].includes(status) && this.$can('change', 'tenderWinnerChangeMethodAccessibility') && this.$can('cancel', 'Tender')
        show = defaultLogic || DTECLogic
      }

      return {
        title,
        btnText,
        firstButton,
        show,
        dataQa: `${this.mode}-${this.tender.tenderNumber || status}`
      }
    }
  },
  components: {
    MenuItem
  },
  props: {
    tender: {
      type: Object,
      required: true,
    },
    list: Boolean,
    mode: {
      type: String,
      validator: function (value) {
        const correct = ['', 'complate_ahead', 'cancel'].indexOf(value) !== -1
        return correct
      },
      default: '',
    }
  },
}
</script>
